export enum EngagementModel {
  TEAM_EXTENSION = 'Team Extension',
  PROJECT = 'Project',
  SOLUTIONS = 'Solutions',
  DEDICATED_TEAM = 'Dedicated Team',
}

export const EngagementModelLabels: Record<EngagementModel, string> = {
  [EngagementModel.TEAM_EXTENSION]: 'Team extension',
  [EngagementModel.PROJECT]: 'Project',
  [EngagementModel.SOLUTIONS]: 'Solutions',
  [EngagementModel.DEDICATED_TEAM]: 'Dedicated team',
};
